import { getLoginUrlParams } from '@gef-ui/redux-common/selectors/appContext';
import compose from "ramda/es/compose";
import join from "ramda/es/join";
import o from "ramda/es/o";
import propEq from "ramda/es/propEq";
import split from "ramda/es/split";
import toLower from "ramda/es/toLower";
import isFunction from "ramda-extension/es/isFunction";
import mapKeys from "ramda-extension/es/mapKeys";
import { getRestUrl } from '../../../facade';
// Expiration of refresh token is taken as 400 BAD REQUEST > seems logic
// https://jira.cpas.cz/browse/API-253
const createOauthFrontendRedirectUrl = o(({ authorizeUrl, ...urlParams })=>getRestUrl(authorizeUrl, {
        urlParams: {
            response_type: 'code',
            ...mapKeys(compose(toLower, join('_'), split(/(?=[A-Z])/)), urlParams)
        }
    }), getLoginUrlParams);
export default ((beforeLogout)=>({ failure, frontendUrl = createOauthFrontendRedirectUrl, customLogoutResolver = propEq(400, 'status') })=>async (dispatch, getState)=>{
            if (customLogoutResolver(failure)) {
                if (beforeLogout) {
                    await dispatch(beforeLogout);
                }
                const gwUrl = isFunction(frontendUrl) ? frontendUrl(getState()) : frontendUrl;
                window.location.assign(gwUrl);
            }
            return Promise.resolve();
        });
